const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const getHeaders = (token = null, isMultipart = false) => {
    const headers = {};
    if (!isMultipart) {
        headers['Content-Type'] = 'application/json';
    }

    const authToken = token || localStorage.getItem('token');
    if (authToken) {
        headers['Authorization'] = `Bearer ${authToken}`;
    }

    return headers;
};

const handleResponse = async (response) => {
    if (response.ok) {
        if (response.status === 204) return null;
        return response.json();
    } else {
        let errorDetail = 'An unexpected error occurred';
        try {
            const errorData = await response.json();
            errorDetail = errorData.detail || errorData.message || response.statusText;
        } catch (e) {
            errorDetail = response.statusText;
        }

        if (response.status === 401) {
            localStorage.removeItem('token');
        }

        throw new Error(errorDetail);
    }
};

const api = {
    auth: {
        login: (email, password) => fetch(`${BASE_URL}/api/auth/login.php`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ email, password })
        }).then(handleResponse),

        register: (data) => fetch(`${BASE_URL}/api/auth/register.php`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data)
        }).then(handleResponse),

        getMe: (token) => fetch(`${BASE_URL}/api/auth/me.php`, {
            headers: getHeaders(token)
        }).then(handleResponse),
    },

    jobs: {
        getAll: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            return fetch(`${BASE_URL}/api/jobs/index.php?${queryString}`, {
                headers: getHeaders()
            }).then(handleResponse);
        },

        getOne: (id) => fetch(`${BASE_URL}/api/jobs/index.php?id=${id}`, { // Note: index.php might need logic update to handle ?id=
            headers: getHeaders()
        }).then(handleResponse),

        create: (data) => fetch(`${BASE_URL}/api/jobs/index.php`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data)
        }).then(handleResponse),

        update: (id, data) => fetch(`${BASE_URL}/api/jobs/index.php?id=${id}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data)
        }).then(handleResponse),

        delete: (id) => fetch(`${BASE_URL}/api/jobs/index.php?id=${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        }).then(handleResponse),
    },

    applications: {
        // Requires FormData
        create: (formData) => fetch(`${BASE_URL}/api/applications/index.php`, {
            method: 'POST',
            headers: getHeaders(null, true), // isMultipart = true
            body: formData // Send FormData directly
        }).then(handleResponse),

        getMy: () => fetch(`${BASE_URL}/api/applications/index.php`, {
            headers: getHeaders()
        }).then(handleResponse),

        // FIXME: These endpoints are missing in backend, using placeholders
        getAll: () => fetch(`${BASE_URL}/api/applications/all.php`, {
            headers: getHeaders()
        }).then(handleResponse),

        getByJob: (jobId) => fetch(`${BASE_URL}/api/applications/job.php?id=${jobId}`, {
            headers: getHeaders()
        }).then(handleResponse),

        updateStatus: (id, status) => fetch(`${BASE_URL}/api/applications/${id}/status?status=${status}`, {
            method: 'PUT',
            headers: getHeaders()
        }).then(handleResponse),
    },

    admin: {
        // FIXME: Missing in backend
        getStats: () => fetch(`${BASE_URL}/api/admin/stats.php`, {
            headers: getHeaders()
        }).then(handleResponse),

        getMessages: () => fetch(`${BASE_URL}/api/admin/messages.php`, {
            headers: getHeaders()
        }).then(handleResponse),

        updateMessageReadStatus: (id, isRead) => fetch(`${BASE_URL}/api/admin/messages.php`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify({ id, is_read: isRead })
        }).then(handleResponse),

        deleteMessage: (id) => fetch(`${BASE_URL}/api/admin/messages.php?id=${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        }).then(handleResponse),
    },

    contact: {
        submit: (data) => fetch(`${BASE_URL}/api/contact/submit.php`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data)
        }).then(handleResponse),
    }
};

export default api;
